import React from 'react';
import Link from 'next/link';

const NavLink = (props) => {
  const { children, link, title, target = '_self', isExternal } = props;
  let properties = { className: 'nav-item' };

  if (isExternal) {
    return (
      <div {...properties}>
        <a 
          className="nav-item-link" 
          href={link} 
          title={title} 
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          {children}
        </a>
      </div>
    );
  }

  return (
    <div {...properties}>
      <Link 
        href={link} 
        title={title} 
        target={target} 
        className="nav-item-link"
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {children}
      </Link>
    </div>
  );
};

export default NavLink;
